/* Formatação para a área admin. Pequeno de propósito — só o que Saúde e
 * Números precisam. Datas vêm da API em ISO; durações, em segundos. */

export function relativo(iso) {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return '—';
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return 'agora';
  const m = Math.round(s / 60);
  if (m < 60) return `há ${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `há ${h} h`;
  return `há ${Math.round(h / 24)} d`;
}

export function duracao(segundos) {
  if (segundos == null) return '—';
  const s = Math.max(0, Math.round(segundos));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const resto = m % 60;
  return resto ? `${h}h ${resto}min` : `${h}h`;
}

/** 5511999998888 → +55 11 99999‑8888. Só para ler; o valor gravado é o JID.
 *
 * O hífen é o NÃO-QUEBRÁVEL (U+2011): num card estreito o número pode quebrar
 * no espaço ("+55 11" / "99999‑8888"), nunca no meio dos dígitos. Proibir a
 * quebra inteira empurrava o selo de estado para fora do card. */
export function telefoneLegivel(telefone) {
  const d = String(telefone || '').replace(/\D/g, '');
  if (d.length < 12) return telefone || '';
  const ddd = d.slice(2, 4);
  const resto = d.slice(4);
  return `+${d.slice(0, 2)} ${ddd} ${resto.slice(0, resto.length - 4)}‑${resto.slice(-4)}`;
}
